import { render, staticRenderFns } from "./m-editSoalChild.vue?vue&type=template&id=fd85182c&"
import script from "./m-editSoalChild.vue?vue&type=script&lang=js&"
export * from "./m-editSoalChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports